import moment from "moment";

const DEFAULT_SEARCH_PARAMS = () => ({
    dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
    dateTo: moment().format("YYYY-MM-DD"),
    iwarehouses: [],
    movementType: "all",
    movementReason: null,
    searchQuery: null,
    queryMode: false,
    currentPage: 1,
    pageSize: 25,
    headers: [],
})

const DEFAULT_CATALOGS = () =>({
  iwarehouses: []
})

const CONSTANT_HEADERS = { 
  iwarehouseName: "Almacen",
  dateOfMovement: "Fecha de movimiento",
  supplyCode: "Código Insumo",
  supplyName: "Descripción",
  supplyUnit: "Unidad",
}
const INPUT_HEADERS = {
  orderBuy: "Motivo",
};
const OUTPUT_HEADERS = {
  sinister: "Siniestro",
  isInvoice: "Facturado",
};
const LAST_CONSTANT_HEADERS = {
  movementQuantityColumn: "Cantidad",
  unitCost: "Costo Unitario",
};

const LOADING_PROPS = {
    emptyLabel: "No hay registros que mostrar.",
    emptyDescription: "Intente más tarde o redefina su consulta.",
  }

export {
  DEFAULT_SEARCH_PARAMS, DEFAULT_CATALOGS, CONSTANT_HEADERS, INPUT_HEADERS, OUTPUT_HEADERS, LAST_CONSTANT_HEADERS, LOADING_PROPS
}


// WEBPACK FOOTER //
// ./src/pages/Reports/InputsOutputsReport/utils.js